import React, { useState, useEffect } from "react";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { getLeadContacts, deleteLeadContact } from "../../../api/leadContacts";
import { usePagination } from "../../../hooks/usePagination";
import PaginationHandler from "../../../components/PaginationHandler";
import CustomTable from "../../../components/CustomTable/CustomTable";
import { Button, Input, Label } from "reactstrap";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";

export default function LeadContactList() {
    const navigate = useNavigate();
    const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
    const role = currentUser.role || currentUser.roleName || "";
    const hasPermission = (action) => {
        if (role.name === "super admin") return true;
        return (
            role.permissions &&
            role.permissions.some(
                (perm) => perm.resource === "Sales" && perm.actions.includes(action)
            )
        );
    };

    const canCreate = () => hasPermission("create");
    const canEdit = () => hasPermission("update");
    const canDelete = () => hasPermission("delete");
    const canRead = () => hasPermission("read");

    useEffect(() => {
        console.log("Current User:", currentUser);
        console.log("Role:", role.name);
        console.log("Permissions:", role.permissions);
        console.log("canCreate:", canCreate());
        console.log("canEdit:", canEdit());
        console.log("canDelete:", canDelete());
        console.log("canRead:", canRead());
    }, [currentUser]);

    const {
        response,
        loading,
        error,
        setPage,
        page,
        setMeta,
        totalPages,
    } = usePagination(getLeadContacts, null, true);

    const [filters, setFilters] = useState({
        type: "",
    });

    function handleFilter() {
        setMeta((meta) => ({
            ...meta,
            page: 1,
            payload: {
                ...filters,
            },
        }));
    }

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this Lead Contact?")) {
            try {
                await deleteLeadContact(id);
                setPage(1);
            } catch (error) {
                console.error("Delete failed:", error);
                alert("Failed to delete Lead Contact.");
            }
        }
    };

    return (
        <div className="page-content">
            <div className="container-fluid">
                <Breadcrumbs
                    title={"Lead Contacts"}
                    addUrl={canCreate() ? "/lead-contacts/add" : null}
                    hasAddBtn={canCreate()}
                    isMainPage={true}
                />

                {/* You can enable filters here if needed */}
                {/* <div className="d-flex align-items-center mb-4" style={{ gap: 20 }}>
          <div className="d-flex align-items-center" style={{ gap: 10 }}>
            <Label>{t("Type")}</Label>
            <Input
              type="text"
              value={filters.type}
              onChange={(e) =>
                setFilters((f) => ({ ...f, type: e.target.value }))
              }
            />
          </div>
          <Button onClick={handleFilter} color="primary">
            {t("Search")}
          </Button>
        </div> */}

                {canRead() || canDelete() || canEdit() ? (
                    response && response.length > 0 && !loading ? (
                        <CustomTable
                            emptyMsg={"No Lead Contacts Found."}
                            data={response}
                            loading={loading}
                            error={error}
                            cols={[
                                // {
                                //   label: "Lead Name",
                                //   key: "leadName",
                                //   style: { width: "20%" },
                                //   renderer: (row) => <>{row.leadId?.name ?? "—"}</>,
                                // },
                                {
                                    label: "Lead Email",
                                    key: "leadEmail",
                                    style: { width: "25%" },
                                    renderer: (row) => <>{row.leadId?.email ?? "—"}</>,
                                },
                                {
                                    label: "Type",
                                    key: "type",
                                    style: { width: "15%" },
                                },
                                {
                                    label: "Notes",
                                    key: "notes",
                                    style: { width: "15%" },
                                },
                                {
                                    label: "Potential Budget",
                                    key: "potentialBudget",
                                    style: { width: "15%" },
                                    renderer: (row) => <>${row.potentialBudget ?? "N/A"}</>,
                                },
                                {
                                    label: "Status",
                                    key: "statusLeadContactId",
                                    style: { width: "15%" },
                                    renderer: (row) => <>{row.statusLeadContactId?.name ?? "—"}</>,
                                },
                                {
                                    label: "Actions",
                                    key: "actions",
                                    style: { width: "15%" },
                                    renderer: (row) => (
                                        <div className="d-flex gap-2">
                                            {canEdit() && (
                                                <Button
                                                    color="info"
                                                    size="sm"
                                                    onClick={() => navigate(`/lead-contacts/edit/${row._id}`)}
                                                >
                                                    Edit
                                                </Button>
                                            )}
                                            {canDelete() && (
                                                <Button
                                                    color="danger"
                                                    size="sm"
                                                    onClick={() => handleDelete(row._id)}
                                                >
                                                    Delete
                                                </Button>
                                            )}
                                        </div>
                                    ),
                                },
                            ]}
                        />
                    ) : (
                        !loading && <div>No results found.</div>
                    )
                ) : (
                    <div>You do not have permission to view this list.</div>
                )}

                {response && !loading && canRead() && (
                    <PaginationHandler page={page} setPage={setPage} totalPages={totalPages} />
                )}
            </div>
        </div>
    );
}
